import PlanDetailPage from '@/components/PlanDetailPage';

const PricingSingleCourse = () => {
  return <PlanDetailPage planId="single-course" />;
};

export default PricingSingleCourse;
